import { NavServiceActivatorConfig } from '../pfe-service-activator/service/service-activator.model';

export interface FolderServiceActivator extends NavServiceActivatorConfig {
  /**
   * The id of the service activator that are gonna be used for the config aggregator
   * to transform the folder service activator in a global service activator.
   *
   * That param its mandatory.
   *
   * @example
   * ```json
   *   {
   *       "serviceActivatorMethod": "FOO",
   *       "serviceActivatorId": "bar",
   *       "path": "/foo/bar/"
   *   }
   * ```
   * Will be transformed in...
   * ```json
   * {
   *      ...,
   *      "serviceActivators": {
   *          "bar": {
   *              "serviceActivatorMethod": "FOO",
   *              "path": "/foo/bar/"
   *          }
   *      }
   * }
   * ```
   */
  serviceActivatorId: string;
}
